import BackendDeveloperPage from "./BackendDeveloperPage";

export default function PhpDeveloperPage() {
  return <BackendDeveloperPage technology="php" />;
}
